import api from '../../common/api';
import { APIError } from '../../constants/errorCode/system';
import httpHelper from '../../helpers/httpHelper';
import BaseServices from '../baseServices';

const voucherServicesV2 = {
  getVoucherBalances: async (params) => {
    try {
      const { id } = params;
      const url = api.voucherV2.getVoucherBalances.replace(':id', id);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  addBalance: async (params) => {
    try {
      const url = api.voucherV2.addVoucherBalances.replace(':id', params.voucherId);
      const data = await BaseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      console.log(24, error);
      return { success: false, code: APIError.ConnectFail };
    }
  },
  removeBalance: async (params) => {
    try {
      const url = api.voucherV2.removeVoucherBalances
        .replace(':id', params.voucherId)
        .replace(':voucherBalanceId', params.id);
      const data = await BaseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  fetchAll: async (params) => {
    // companyId, month, year, keyword, source, paymentStatus, limit, page
    try {
      const queryParams = httpHelper.serialize(params);
      const url = `${api.voucherV2.fetchAll}?${queryParams}`;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getDetails: async (id) => {
    // companyId, month, year, keyword, source, paymentStatus, limit, page
    try {
      const url = api.voucherV2.getDetails.replace(':id', id);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  // params.systemCode (e.g. FIKEN) adds the suggested account / vatType per line (purchase form auto-fill)
  getVoucherExtract: async (id, params = {}) => {
    try {
      const query = httpHelper.serialize(params);
      const url = api.voucherV2.getVoucherExtract.replace(':id', id) + (query ? `?${query}` : '');
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  listVouchersSameSupplier: async (params) => {
    try {
      const { id, ...queryParams } = params;
      const query = httpHelper.serialize(queryParams);
      const baseUrl = api.voucherV2.listVouchersSameSupplier.replace(':id', id);
      const url = query ? `${baseUrl}?${query}` : baseUrl;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  addVoucherAllocation: async (params) => {
    try {
      const url = api.voucherV2.addVoucherAllocation.replace(':id', params.id);
      const data = await BaseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  removeVoucherAllocation: async (params) => {
    try {
      const { voucherId, allocationId, companyId } = params;

      const baseUrl = api.voucherV2.removeVoucherAllocation
        .replace(':id', voucherId)
        .replace(':allocationId', allocationId);

      const query = httpHelper.serialize({ companyId });
      const url = `${baseUrl}?${query}`;

      const data = await BaseServices.deleteDataToken(url);
      const result = await data.json();

      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getEhfCreditNotes: async (params) => {
    // companyId, paymentStatus (optional, 0 = unpaid)
    try {
      const queryParams = httpHelper.serialize(params);
      const url = `${api.voucherV2.getEhfCreditNotes}?${queryParams}`;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
};

export default voucherServicesV2;
